import React from 'react';

import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import FormControl from 'react-bootstrap/FormControl';
import InputGroup from 'react-bootstrap/InputGroup';
import { FaSearch } from 'react-icons/fa';

import './styles.scoped.css';

const TableFilter = ({ className, columns, onSearchChange }) => {
  const [filterBy, setFilterBy] = React.useState();
  // Only offer columns this control can actually filter on. The menu is keyed by `Header`
  // and `eventKey=""` is reserved below for "All", so a column with an empty `Header`
  // collides with it, and a column with no `accessor` gives the caller nothing to hand to
  // react-table's setFilter (which throws "Could not find a column with id: undefined").
  // Action/button columns are exactly that shape, so they are dropped here.
  const dropdownOptions = columns
    .filter(({ Header, accessor }) => Header && accessor)
    .map(({ Header }) => (
      <Dropdown.Item key={Header} eventKey={Header} onSelect={setFilterBy}>
        {Header}
      </Dropdown.Item>
    ));
  return (
    <InputGroup className={className}>
      <DropdownButton
        as={InputGroup.Prepend}
        title={
          <span>
            <FaSearch /> {filterBy}
          </span>
        }>
        <Dropdown.Item eventKey="" onSelect={setFilterBy}>
          All
        </Dropdown.Item>
        {dropdownOptions}
      </DropdownButton>
      <FormControl
        onChange={event => {
          onSearchChange(event, filterBy);
        }}
      />
    </InputGroup>
  );
};

export default TableFilter;
